import { useQuery } from '@tanstack/react-query';

import { getAccount, listAccounts, listActions, listDiscounts } from '@/api/dba-api';
import { dbaKeys } from './query-keys';

export function useAccounts(q: string) {
  return useQuery({ queryKey: dbaKeys.accounts(q), queryFn: () => listAccounts(q) });
}

export function useAccount(accountId: number) {
  return useQuery({ queryKey: dbaKeys.account(accountId), queryFn: () => getAccount(accountId) });
}

export function useDiscounts() {
  return useQuery({ queryKey: dbaKeys.discounts, queryFn: listDiscounts });
}

export function useActions(limit: number) {
  return useQuery({ queryKey: dbaKeys.actions(limit), queryFn: () => listActions(limit) });
}
